export const MULTIPLE_LANGUAGE_MAP = {
  Arabic: 'لعربية',
  Czech: 'Čeština',
  Dutch: 'Nederlands',
  English: 'English',
  French: 'Français',
  German: 'Deutsch',
  Hindi: 'हिन्दी',
  Indonesian: 'Bahasa Indonesia',
  Italian: 'Italiano',
  Japanese: '日本語',
  Korean: '한국어',
  Persian: 'فارسی',
  Polish: 'Polski',
  Portuguese: 'Português',
  Spanish: 'Español',
  Thai: 'ไทย',
  Turkish: 'Türkçe',
  Ukrainian: 'Українська',
  Vietnamese: 'Tiếng Việt',
};

export const MULTIPLE_LANGUAGE_LIST = [
  { name: 'Japanese', slug: '' },
  { name: 'English', slug: 'en' },
  { name: 'Spanish (Spain)', slug: 'es' },
  { name: 'Portuguese (Portugal)', slug: 'pt' },
  { name: 'French (France)', slug: 'fr' },
  { name: 'Indonesian', slug: 'id' },
  { name: 'Czech', slug: 'cs' },
  { name: 'German (Germany)', slug: 'de' },
  { name: 'Italian', slug: 'it' },
  { name: 'Dutch', slug: 'nl' },
  { name: 'Polish', slug: 'pl' },
  { name: 'Turkish', slug: 'tr' },
  { name: 'Ukrainian', slug: 'uk' },
  { name: 'Korean', slug: 'ko' },
  { name: 'Arabic (United Arab Emirates)', slug: 'ar' },
  { name: 'Persian', slug: 'fa' },
  { name: 'Thai', slug: 'th' },
  { name: 'Hindi (India)', slug: 'hi' },
  { name: 'Vietnamese', slug: 'vi' },
];

export const MULTIPLE_LANGUAGE_RENDER_LIST = [
  { label: 'English', slug: 'en' },
  { label: '日本語', slug: '' },
  { label: 'Deutsch', slug: 'de' },
  { label: 'Français', slug: 'fr' },
  { label: 'Español', slug: 'es' },
  { label: 'Português', slug: 'pt' },
  { label: 'Bahasa Indonesia', slug: 'id' },
  { label: 'Čeština', slug: 'cs' },
  { label: 'Italiano', slug: 'it' },
  { label: 'Nederlands', slug: 'nl' },
  { label: 'Polski', slug: 'pl' },
  { label: 'Türkçe', slug: 'tr' },
  { label: 'Tiếng Việt', slug: 'vi' },
  { label: 'Українська', slug: 'uk' },
  { label: '한국어', slug: 'ko' },
  { label: 'لعربية', slug: 'ar' },
  { label: 'فارسی', slug: 'fa' },
  { label: 'ไทย', slug: 'th' },
  { label: 'हिन्दी', slug: 'hi' },
];
